// extracted by mini-css-extract-plugin
export default {"Box":"base-cell-module__Box--bqkLG","Box_1":"base-cell-module__Box_1--z9MzV"};